// extracted by mini-css-extract-plugin
module.exports = {"root":"common_root__R1guO","loader":"common_loader__JafbT","section":"common_section__xDQPN"};